import React from 'react';
import { gql, useFragment } from '@apollo/client';
import css from './schoolDetails.module.scss';
import '../../dishDetailsWithCustom.scss';

import boxImage from './img/whatInsideSchool.jpg';
import d1 from './img/school-d1.jpg';
import d2 from './img/school-d2.jpg';
import d3 from './img/school-d3.jpg';


const SchoolSetDescription = () => (
    <div className={css.cardsList}>
        <div className={css.secondaryCard}>
            <img className={css.secondaryCardImage} src={d1} alt="Сосиски в тесте" />
            <div className={css.cardTitle}>1. Сосиски в тесте</div>
            <ul className={css.descriptionList}>
                <li>сосиски из натурального мяса индейки и говядины</li>
                <li>готовое дрожжевое тесто</li>
                <li>фирменный соус и специи от шефа</li>
                <li>рецепт-инструкция</li>
            </ul>
        </div>

        <div className={css.secondaryCard}>
            <img className={css.secondaryCardImage} src={d2} alt="Шоколадная колбаса" />
            <div className={css.cardTitle}>2. Шоколадная колбаса</div>
            <ul className={css.descriptionList}>
                <li>традиционное печенье</li>
                <li>варёная сгущёнка в банке</li>
                <li>натуральный какао</li>
                <li>грецкие орехи</li>
                <li>и всё необходимое в нужных пропорциях</li>
                <li>плюс рецепт-инструкция</li>
            </ul>
        </div>

        <div className={css.secondaryCard}>
            <img className={css.secondaryCardImage} src={d3} alt="Приятные мелочи" />
            <div className={css.cardTitle}>3. Приятные мелочи</div>
            <ul className={css.descriptionList}>
                <li>домашний компот из яблок (уже готов) — вкус наливных яблок из бабушкиного сада</li>
                <li>драже «Сахарные часики» - топовое украшение «тех времён», чтобы надеть на руку и похрустеть</li>
                <li>игра «Морской бой» — чтобы вспомнить, как с задней парты шёпотом раздавались: «А5!», «Мимо!»</li>
            </ul>
        </div>
    </div>
);

export const SchoolDetails = () => {
    const { data } = useFragment({
        fragment: gql`fragment DISH_TITLE on menuDish {
            title
            caption
        }`,
        from: {
            __ref: 'menuDish:5505',
        },
    });

    const title = data?.title;
    const caption = data?.caption;
    return (
        <div className={css.schoolDetailsRoot}>
            <div className={css.schoolDishTitle}>
                Подарок учителю
            </div>
            <div className={css.mainCard}>
                <h2 className={css.mainCardTitle}>Что в наборе</h2>
                <img className={css.descriptionCardImage} src={boxImage} alt="description card" />
                <div className={css.descriptionCard}>
                    <ul className={css.descriptionList}>
                        <li>Всё для приготовления 4 сосисок в тесте — тех самых, ради которых ждали большую перемену</li>
                        <li>Всё для приготовления шоколадной колбасы по рецепту из детства</li>
                        <li>Готовый домашний компот из яблок</li>
                        <li>Пошаговые рецепты с атмосферой СССР</li>
                        <li>Приятные мелочи, чтобы вспомнить детство</li>
                    </ul>
                </div>
            </div>
            <div className={css.schoolSetList}>
                <SchoolSetDescription />
            </div>
        </div>
    );
};
